import { NullQ } from "@pdfking/structs"

import type { CacheBackend } from "#public"

import { MemoryStore } from "../backends/memory/MemoryStore"

export const CacheFunction = <T, G>(
  fn: (or: G) => Promise<T>,
  key_func: (v: G) => string,
  backend?: CacheBackend<T>
): ((expr: G) => Promise<T>) => {
  const cache = backend || MemoryStore<T>()

  return async (expr: G): Promise<T> => {
    const key = key_func(expr)

    const cached = await cache.get(key)

    if (NullQ(cached)) {
      const result = await fn(expr)
      await cache.set(key, result)
      return result
    }
    return cached
  }
}
